import { Component, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-line-item-import-dialog',
  templateUrl: './line-item-import-dialog.html',
  styleUrls: ['./line-item-import-dialog.css']
})
export class LineItemImportDialog {
  Hvr: any = {};
  errorMessage: string = '';
  searchOpts:LineItemSearchParams = new LineItemSearchParams('file', '', '' ,'' , '', [], []);
  constructor(
    public dialogRef: MatDialogRef<LineItemImportDialog>,
    @Inject(MAT_DIALOG_DATA) public lineItems: Array<string>) {
  }

  optionSelected(){
    this.searchOpts.extractedLineItems.length = 0;
    this.searchOpts.lineItems.length = 0;
  }

  onFileChange(evt: any) {
    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, {type: 'binary'});

      /* grab first sheet */
      var _tmpSerials:Array<string> = [];
      this.searchOpts.extractedLineItems.length = 0;
      this.searchOpts.lineItems.length = 0;
      for(var i = 0; i < wb.SheetNames.length; i++){
        const wsname: string = wb.SheetNames[i];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];  
        const regexp = /^[0-9]*$/;
        
        var _jsonArr:Array<any> = XLSX.utils.sheet_to_json(ws, {header: 1});
        console.log("_jsonArr",_jsonArr);
        
        for(var j = 0;j < _jsonArr.length; j++){
          if(_jsonArr[j].length > 0){
            for(var k = 0;k < _jsonArr[j].length;k++){
              if(_jsonArr[j][k] && typeof parseInt(_jsonArr[j][k],10) === 'number' && _jsonArr[j][k].match(regexp)){
                _tmpSerials.push(_jsonArr[j][k].trim());
              }
            }
          }
        }
      }

      this.searchOpts.extractedLineItems = _tmpSerials.filter((_token:string) => { return _token.trim() != ""; });
      this.searchOpts.lineItems.push(..._tmpSerials);
      
      /* save data */
      //this.data = <AOA>(XLSX.utils.sheet_to_json(ws, {header: 1}));
    };
    reader.readAsBinaryString(target.files[0]);
  }


  removeLineIt(_lnIt:string){
    while(this.searchOpts.lineItems.indexOf(_lnIt) >= 0){
      this.searchOpts.lineItems.splice(this.searchOpts.lineItems.indexOf(_lnIt), 1);
    }
  }

  getLineItemCountMessage():string{
    if(this.searchOpts.extractedLineItems.length == 0){
      return "No line items extracted.";
    }
    else if(this.searchOpts.extractedLineItems.length == this.searchOpts.lineItems.length){
      return "Showing " + this.searchOpts.extractedLineItems.length + " line items extracted."
    }
    else{
      return "Selected " + this.searchOpts.lineItems.length + " of " + this.searchOpts.extractedLineItems.length + " extracted.";
    }
  }
  extractLineItemsPasted(){
    var _tokens:Array<string> = this.searchOpts.pastedLineItemsStr.split(/,|-|\t|\r|\n| /);

    this.searchOpts.extractedLineItems = _tokens.filter((_token:string) => { return _token.trim() != ""; });

    this.searchOpts.lineItems.splice(0,this.searchOpts.lineItems.length,...this.searchOpts.extractedLineItems)
    //this.lineItems = this.extractedSerialNumbers.slice(0);
  }


  extractLineItemsFromTo(){
    this.searchOpts.lineItems.length = 0;
    this.searchOpts.lineItemExtractMessage = "";
    if(this.isRangeLineItemsValid() == true){
      var _rngSerials:Array<string> = this.getRangeLineItems();
      if(_rngSerials != null){
        this.searchOpts.extractedLineItems = _rngSerials.filter((_token:string) => { return _token.trim() != ""; });
        this.searchOpts.lineItems.push(..._rngSerials);
      }
    }
  }
  getRangeLineItems():Array<string>{
    //to retain exisitng format in case leading zeros, add 1
    var _fromLineItemStart:string = this.searchOpts.fromLineItem.substring(0,4);
    var _toLineItemStart:string = this.searchOpts.fromLineItem.substring(0,4);
    var _fromLineItemNo:number = parseInt(( this.searchOpts.fromLineItem),10);
    var _toLineItemNo:number = parseInt((this.searchOpts.toLineItem),10);
    // console.log(_fromLineItemStart,_toLineItemStart,_fromLineItemNo,_toLineItemNo)
    if(Number.isNaN(_fromLineItemNo) || Number.isNaN(_toLineItemNo)){
      this.searchOpts.lineItemExtractMessage = "Line Item is NOT VALID";
      return null;
    }
    if(_fromLineItemNo > _toLineItemNo){
      this.searchOpts.lineItemExtractMessage = "From Line Item Cannot be more than To Line Item.";
      return null;
    }
    if(_toLineItemNo == _fromLineItemNo){
      this.searchOpts.lineItemExtractMessage = "From Line Item Cannot be equal to To Line Item.";
      return null;
    }
    if(_toLineItemNo - _fromLineItemNo > 5000){
      this.searchOpts.lineItemExtractMessage = "You cannot view more than 5000 line items at a glance.";
      return null;
    }

    var _retVal:Array<string> = [];
    for(var i = _fromLineItemNo;i <= _toLineItemNo; i+=10){
      //remove the leading one added earlier
      _retVal.push((i + ''));
    }
    return _retVal;
  }
  isRangeLineItemsValid():boolean{
    if(this.searchOpts.fromLineItem.trim() == ""  || this.searchOpts.toLineItem.trim() == ""){
      this.searchOpts.lineItemExtractMessage = "Line Items CANNOT be empty";
      return false;
    }
    // if(this.searchOpts.fromLineItem.toLowerCase().indexOf("1vy") != 0  || 
    //    this.searchOpts.toLineItem.toLowerCase().indexOf("1vy") != 0){
    //   this.searchOpts.lineItemExtractMessage = "Line Items SHOULD start with 1VY";
    //   return false;
    // }
    return true;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  confirmClick() {
    // this.errorMessage = '';
    // if (this.data.plannedDate && this.data.actualDate) {
    //   if (this.data.actualDate > this.data.plannedDate) {
    //     if (this.data.comments == null || this.data.comments == '') {
    //       this.errorMessage = '* Please Enter Reason for Delay';
    //       return;
    //     }
    //   }
    // }
    this.lineItems.push(...this.searchOpts.extractedLineItems);
    this.dialogRef.close(true);
  }
}

export class LineItemSearchParams{
    constructor(public lineItemOptSelection:string,  public pastedLineItemsStr:string,
        public fromLineItem:string, public toLineItem:string, public lineItemExtractMessage:string,
        public extractedLineItems:Array<string>, public lineItems:Array<string>){}
}